import { render } from "./TeamPageA.vue?vue&type=template&id=67cfc520&scoped=true"
import script from "./TeamPageA.vue?vue&type=script&lang=js"
export * from "./TeamPageA.vue?vue&type=script&lang=js"

import "./TeamPageA.vue?vue&type=style&index=0&id=67cfc520&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cfc520"]])

export default __exports__